define( function() {

"use strict";

function nodeName( elem, name ) {

	return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

}

return nodeName;

} );



//////////////////
// WEBPACK FOOTER
// ./node_modules/jquery/src/core/nodeName.js
// module id = 8
// module chunks = 0 1 2 3 4